import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip
} from 'chart.js'
import PropTypes from 'prop-types'
import { Bar } from 'react-chartjs-2'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

const BarChart = ({ data, options }) => {
  return <Bar data={data} options={options} />
}

BarChart.propTypes = {
  data: PropTypes.object.isRequired,
  options: PropTypes.object
}

export default BarChart
